import React, { useEffect, useLayoutEffect, useRef } from 'react';
import './LibrarySearchBar.css';

export default function LibrarySearchBar({ value, onChange, mode, onModeChange }) {
  const toggleRef = useRef(null);
  const sliderRef = useRef(null);
  const globalBtnRef = useRef(null);
  const personalBtnRef = useRef(null);
  const globalLabelRef = useRef(null);
  const personalLabelRef = useRef(null);

  const updateSlider = () => {
    const container = toggleRef.current;
    const slider = sliderRef.current;
    if (!container || !slider) return;

    const targetLabel = mode === 'global' ? globalLabelRef.current : personalLabelRef.current;
    const targetBtn = mode === 'global' ? globalBtnRef.current : personalBtnRef.current;
    if (!targetLabel || !targetBtn) return;

    const cRect = container.getBoundingClientRect();
    const tRect = targetLabel.getBoundingClientRect();

    // Symmetric padding around label text
    const horizontalPadding = 12; // px padding on each side
    const left = Math.max(4, Math.round(tRect.left - cRect.left - horizontalPadding));
    const width = Math.round(tRect.width + horizontalPadding * 2);

    slider.style.left = left + 'px';
    slider.style.width = width + 'px';
  };

  useLayoutEffect(() => {
    updateSlider();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode, value]);

  useEffect(() => {
    const ro = new ResizeObserver(() => updateSlider());
    if (toggleRef.current) ro.observe(toggleRef.current);
    if (globalBtnRef.current) ro.observe(globalBtnRef.current);
    if (personalBtnRef.current) ro.observe(personalBtnRef.current);
    window.addEventListener('resize', updateSlider);
    const id = requestAnimationFrame(updateSlider);
    return () => {
      ro.disconnect();
      window.removeEventListener('resize', updateSlider);
      cancelAnimationFrame(id);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="library-searchbar">
      <input
        type="text"
        className="library-search-input"
        placeholder="Search by title, description..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <div ref={toggleRef} className={`library-mode-toggle ${mode}`} role="group" aria-label="Mode toggle">
        <button
          ref={globalBtnRef}
          className={`mode-btn ${mode === 'global' ? 'active' : ''}`}
          onClick={() => onModeChange('global')}
        >
          <span ref={globalLabelRef} className="mode-label">Global</span>
        </button>
        <div ref={sliderRef} className="mode-slider" />
        <button
          ref={personalBtnRef}
          className={`mode-btn ${mode === 'personal' ? 'active' : ''}`}
          onClick={() => onModeChange('personal')}
        >
          <span ref={personalLabelRef} className="mode-label">Personal</span>
        </button>
      </div>
    </div>
  );
}


